import Vue from 'vue';
import moment from 'moment';
import exciseReportTransformer from './../../transformers/exciseReport';

const success = ({ data }, resolve) => {
  const report = data.map(r => ({
    period: r.period,
    entries: exciseReportTransformer.fetchCollection(r.entries),
  }));

  resolve(report);
};

const failed = (error, reject) => reject(error);


export default (dateRange, limit = null) => (
  new Promise((resolve, reject) => {
    let url = '/reports/excise_entries';
    const query = [];

    if (limit) {
      query.push(`limit=${limit}`);
    }

    if (dateRange) {
      query.push(`month=${moment(dateRange).format('YYYY-MM-DD')}`);
    }

    if (query.length > 0) {
      url += '?';
      query.map((q) => {
        url += `${q}&`;
        return q;
      });
      url = url.substring(0, url.length - 1);
    }

    Vue.$http.get(url)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/report/excises.js